import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3606448e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_2 = { class: "obiettivoLineContainer" }
const _hoisted_3 = { class: "obiettivoLine target" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "Target", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "Io", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "right",
          style: _normalizeStyle(_ctx.targetWidth)
        }, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.vm.obiettivo)), 5)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["obiettivoLine result", { red: !_ctx.isOver, green: _ctx.isOver }])
      }, [
        _hoisted_5,
        _createElementVNode("div", {
          class: "right",
          style: _normalizeStyle(_ctx.resultWidth)
        }, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.vm.risultato)), 5)
      ], 2)
    ])
  ]))
}